/**
 * index starts at 1 here, zero is the root of
 * the application and is not a route
 */
export enum AppRouteLevel {
  PRIMARY = 1,
  SECONDARY = 2,
  TERTIARY = 3,
}
